export {default as selector} from './src/event-selector';



// WEBPACK FOOTER //
// ./~/vega-event-selector/index.js